var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer py-50 py-lg-60"
  }, [_c('div', {
    staticClass: "footer-bg off-area"
  }), _c('v-container', [_c('div', {
    staticClass: "footer__inner d-flex flex-column-reverse flex-md-row justify-space-between"
  }, [_c('div', {
    staticClass: "footer__inner-bg off-area"
  }), _c('div', [_c('div', {
    staticClass: "familysite-wrap mb-30 mb-lg-34"
  }, [_c('button', {
    staticClass: "familysite"
  }, [_vm._v(" Family Site "), _c('v-icon', {
    staticClass: "v-icon notranslate mdi mdi-chevron-down theme--light"
  })], 1), _c('ul', {
    staticClass: "familysite-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://supportworks.kr/",
      "target": "_blank"
    }
  }, [_vm._v(" 서포트웍스 ")])])])]), _c('p', {
    staticClass: "footer__info color-grey-5 line-height-18 font-size-12 font-size-lg-14"
  }, [_vm._v(" 세일즈웍스 코리아"), _c('span', {
    staticClass: "d-none d-lg-inline-block text-center w-20px"
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-lg-none"
  }), _vm._v(" 서울특별시 강남구 논현로 419 PMK 1층"), _c('span', {
    staticClass: "d-none d-lg-inline-block text-center w-20px"
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-lg-none"
  }), _vm._v(" 대표전화 02-1600-3939"), _c('span', {
    staticClass: "d-none d-lg-inline-block text-center w-20px"
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-lg-none"
  }), _vm._v(" 팩스 02-558-2320 "), _c('br'), _vm._v(" Ⓒ 2022 SalesWorks Korea. All right reserved. ")])]), _c('div', {
    staticClass: "off-area"
  }, [_c('v-img', {
    staticClass: "mt-lg-28 mb-30 mb-md-0 footer-logo",
    attrs: {
      "src": "/images/ci2.svg",
      "max-width": "118"
    }
  })], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }